import styled from 'styled-components';

interface pageContainerProps {
	margin?: string;
	padding?: string;
	width?: string;
	overFlow?: string;
	flexColumn?: boolean;
	AlignCenter?: boolean;
	onlyVerticalScroll?: boolean;
	homePage?: boolean;
}
const PageContainer = styled.div<pageContainerProps>`
	display: inline-block;
	width: 100%;
	margin: ${({ margin }) => margin}!important;
	width: ${({ width }) => width}!important;
	// padding: ${({ padding }) => padding}!important;
	position: relative;
	overflow: auto;
	overflow: ${({ overFlow }) => overFlow}!important;
	padding-right: 30px;
	padding-left: 30px;
	padding-top: 30px;
	margin-right: auto;
	margin-left: auto;
	${({ flexColumn }) =>
		flexColumn &&
		`flex-direction: column;
    `};
	${({ AlignCenter }) =>
		AlignCenter &&
		`justify-content: center;
    `};
	${({ onlyVerticalScroll }) =>
		onlyVerticalScroll &&
		`overflow-y: auto;
        overflow-x: hidden;
	`};
	${({ homePage }) =>
		homePage &&
		`padding:0!important;
		margin:0 -15px!important;
		width: calc(100% - -60px);
	`};
`;
export default PageContainer;
